import { useQuery } from "@tanstack/react-query"
import { getFundDashboard } from "@/api/irr"
import { IrrFundDashboard } from "@/types"

export const useIrrDashboard = () => {
  const query = useQuery<IrrFundDashboard[]>({
    queryKey: ["irrDashboard"],
    queryFn: () => getFundDashboard(),
    staleTime: 1000 * 60 * 5,
  })

  return {
    ...query,
    data: query.data || [],
  }
}
